import { createGlobalStyle } from 'styled-components';

const FontsStyles = createGlobalStyle`
  @font-face {
    font-family: "SF Pro";
    src: url("/fonts/sf-pro-medium.woff2") format("woff2");
    font-weight: 500;
    font-display: swap;
    font-style: normal;
  }

  @font-face {
    font-family: "SF Pro";
    src: url("/fonts/sf-pro-medium-italic.woff2") format("woff2");
    font-weight: 500;
    font-display: swap;
    font-style: italic;
  }
  
  @font-face {
    font-family: "SF Pro";
    src: url("/fonts/sf-pro-semibold.woff2") format("woff2");
    font-weight: 600;
    font-display: swap;
    font-style: normal;
  }
  
  @font-face {
    font-family: "SF Pro";
    src: url("/fonts/sf-pro-semibold-italic.woff2") format("woff2");
    font-weight: 600;
    font-display: swap;
    font-style: italic;
  }
  
  @font-face {
    font-family: "SF Pro";
    src: url("/fonts/sf-pro-bold.woff2") format("woff2");
    font-weight: 600;
    font-display: swap;
    font-style: normal;
  }
  
  @font-face {
    font-family: "SF Pro";
    src: url("/fonts/sf-pro-bold-italic.woff2") format("woff2");
    font-weight: 600;
    font-display: swap;
    font-style: italic;
  }
`;

export { FontsStyles };
